import { schema } from "normalizr";
import * as _ from "lodash";
import objectHash from "object-hash";

import { reduceDisplayFilters } from "../favourites/schemas";

/**
 * Saved chart entity
 */
const chart = new schema.Entity(
  "chart",
  {},
  {
    idAttribute: ({ variantId }, { id }) => `${id}-${variantId}`,
    processStrategy: (chart, parent) => {
      const { id: parentID } = parent;
      const { variantId, chartType, dateRange, displayFilters, ...rest } = chart;

      return {
        dateRange,
        id: `${parentID}-${variantId}`,
        variantID: variantId,
        view: _.camelCase(chartType),
        displayFilters: reduceDisplayFilters(displayFilters),
        ...rest
      };
    }
  }
);

const group = new schema.Entity(
  "group",
  {
    charts: new schema.Array(chart)
  },
  {
    idAttribute: ({ groupName }, parent, key) => {
      return `${key}-${_.camelCase(groupName)}`;
    },
    processStrategy: ({ groupName, charts }, parent, key) => {
      return {
        id: `${key}-${_.camelCase(groupName)}`,
        groupName,
        charts
      };
    }
  }
);

const page = new schema.Array(group);

const savedCharts = new schema.Object({
  pages: new schema.Values(page)
});

export default {
  savedCharts
};
